export default {
    MetersToFeet: 3.280839895,
    CmToFeet: 0.032808399,
    CmToMiles: 0.00000621371192,
    CmToMeters: 0.01,
    CmToKm: 0.00001,
    CmToInches: 0.3937,
    MetersToKm: 0.001,
    MetersToMiles: 0.0006213712,
    MilesToMeters: 1609.344,
    KmToCm: 100000,
    KmToMeters: 1000,
    KmToMiles: 0.621371,
    KmToYards: 1093.61,
    JoulesToKiloCal: 0.238662345,
    CaloriesToJoules: 4.19002,
    MpsToKph: 3.60000101,
    MpsToMph: 2.23693692,
    MetersToYards: 1.0936133,
    YardsToMeters: 0.9144,
    YardToMeters: 0.9144,
    YardsToMiles: 0.0005681,
    YardsToKm: 0.0009144,
    KphToMps: 0.27777778,
    MphToMps: 0.4470400035763,
    MilesToYards: 1760,
    MilesToKm: 1.60934,
    KgPerLiterToGramPerLiter: 1000,
    GramsToKg: 0.001,
    GramsToLbs: 0.00220462,
    GramsToSt: 0.00015747,
    GramsOfCarbsToCalories: 4,
    KgToGrams: 1000,
    LbToGrams: 453.592,
    StToGrams: 6350.293,
    StToLbs: 14,
    LbsToSt: 0.07142857,
    FeetToMeters: 0.3048,
    MeterSecTo100YardHour: 39.3700787402,
    MeterSecTo100MeterHour: 36,
    FloorsToMeters: 3.048,
    FloorsToFeet: 10,
    MpsToFeetPerMinute: 196.85,
    FeetPerMinuteToMps: 0.0051,
    CmPerMsToMps: 10,
    SecondsToMs: 1000,
    KnotsToMph: 1.15078,
    KnotsToKmph: 1.852,
    MillilitersToFluidOunces: 0.0338140227,
    MillilitersToCups: 0.0042267528,
    FluidOuncesToMilliliters: 29.5735,
    CupsToMilliliters: 236.588,
    HydphToMps: 0.0254, // hydph = hecto yards per hour
    HmphToMps: 0.0277777778, // hmph = hecto meters per hour
    MinutesPerMeter: 0.1666666667,
    MinutesPerYard: 0.1524,
    MinutesPerMile: 2.68224,
    MinutesPerKilometer: 1.666666667,
    MpsToMilesPerMinute: 0.0372822715, // Meters/second to miles/minute
    MilesPerMinuteToMps: 26.822400024633694, // 1 / MpsToMilesPerMinute
    MpsToKmPerMinute: 0.05999999988, // Meters/second to km/minute
    KmPerMinuteToMps: 16.6666667, // 1 / MpsToKmPerMinute
    MpsToKnots: 1.94384,
    MetersToNauticalMiles: 0.000539957,
    CmToNauticalMiles: 0.00000539957,
    NauticalMilesToMeters: 1852,
    KnotsToMps: 0.514444,
    MillimetersToMeters: 1000,
    MpsToMilesPerSecond: 1609.344,
    MpsToKilometerPerSecond: 1000,
    MetersToCm: 100
};
